
/**
 * 格式化日期
 * @param {String} reg 日期格式
 * @param {Number} data 时间戳/时间字符
 */
let formatDate = function (reg, data) {
  if (!reg || !data) {
    return "";
  }
  if (isNaN(Number(data))) {
    data = Number(new Date(data.replace(/-/g, "/")));
  }

  if (data.toString().length === 10) {
    data *= 1000;
  }
  if (typeof data != "number") {
    data = Number(data);
  }
  let time = new Date(data);
  let o = {
    "M+": time.getMonth() + 1, //月份 
    "d+": time.getDate(), //日 
    "h+": time.getHours(), //小时 
    "m+": time.getMinutes(), //分 
    "s+": time.getSeconds(), //秒 
    "q+": Math.floor((time.getMonth() + 3) / 3), //季度 
    "S": time.getMilliseconds() //毫秒 
  };
  if (/(y+)/.test(reg)) {
    reg = reg.replace(RegExp.$1, (time.getFullYear() + "").substr(4 - RegExp.$1.length));
  }
  for (let k in o) {
    if (new RegExp("(" + k + ")").test(reg)) {
      reg = reg.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    }
  }
  return reg;
}

module.exports = formatDate;


//////////////////
// WEBPACK FOOTER
// ./utils/FDate.js
// module id = t43r
// module chunks = 1